// System Health's status legend is a registered component because the matrix
// page is lazy-loaded. `childExtends` resolves component names through the
// workspace registry, rather than through a page module's local exports.
//
// `s.color` is the status's dot INK (pages/system.js STATUS: the AA-safe
// successInk / warningInk / dangerInk, or a quiet neutral) — the same ink the
// matrix cell's chip paints, so the legend and the cells agree.
export const SystemStatusLegendItem = {
  flow: 'x',
  align: 'center left',
  gap: 'Y',
  Dot: {
    width: 'X2',
    height: 'X2',
    round: 'radiusPill',
    flexShrink: '0',
    background: (el, s) => s.color
  },
  // `s.label` is a bundle KEY (pages/system.js STATUS) — the KEY-IN-STATE form.
  Label: {
    tag: 'span',
    fontSize: 'Z',
    color: 'caption',
    text: (el, s) => el.call('polyglot', s.label || '')
  }
}
